import {writable} from "src/engine/core/utils"

export const notificationsLastChecked = writable(0)
